var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{attrs:{"dis-hover":"","bordered":false}},[_c('indexTableQuery',{ref:"queryTable",on:{"on-submit":_vm.getData,"on-reset":_vm.getData}}),_c('indexTableList',{ref:"table"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }